var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ciam-page',[_c('ciam-three-steps-process',{attrs:{"steps":_vm.fillSteps()}}),_c('ciam-help-creation-success',{staticClass:"margin-top-help"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }